// Comparative plan matrix for the onboarding - HARDCODED mirror of the
// "Plan y uso" tab in Parrotfy core (ServicePlanDefinition: FEATURE_SECTIONS,
// PLAN_FEATURES, CARD_LIMIT_CODES/PLAN_LIMITS, labels from
// config/locales/es.yml under administration.service_plan_dashboard).
// If a plan/feature changes in the core, update this file to match.
// feature_vb_sale_invoices is hidden in the core cards (HIDDEN_FEATURE_CODES)
// and therefore omitted here too. Limit value 0 = ilimitado.

export const PLAN_KEYS = ['starter', 'pro', 'business'];

export const FEATURE_SECTIONS = [
  {
    key: 'sales',
    label: 'Ventas',
    features: [
      { code: 'feature_pos', label: 'Punto de venta (POS)', starter: true, pro: true, business: true },
      { code: 'feature_ecommerce', label: 'E-commerce', starter: false, pro: true, business: true },
      { code: 'feature_massive_sales', label: 'Ventas masivas', starter: false, pro: true, business: true },
      { code: 'feature_recurring_sales', label: 'Ventas recurrentes', starter: false, pro: true, business: true },
      { code: 'feature_subscriptions', label: 'Suscripciones', starter: false, pro: true, business: true },
      { code: 'feature_multi_currency_sales', label: 'Ventas multimoneda', starter: false, pro: true, business: true }
    ]
  },
  {
    key: 'purchases',
    label: 'Compras',
    features: [
      { code: 'feature_purchases', label: 'Compras', starter: true, pro: true, business: true },
      {
        code: 'feature_multi_currency_purchase_order',
        label: 'Órdenes de compra multimoneda',
        starter: false,
        pro: false,
        business: true
      }
    ]
  },
  {
    key: 'crm',
    label: 'Clientes y CRM',
    features: [
      { code: 'feature_clients', label: 'Clientes', starter: true, pro: true, business: true },
      { code: 'feature_client_surveys', label: 'Encuestas a clientes', starter: false, pro: true, business: true },
      { code: 'feature_consultas', label: 'Consultas', starter: false, pro: true, business: true }
    ]
  },
  {
    key: 'productivity',
    label: 'Proyectos y productividad',
    features: [
      { code: 'feature_projects', label: 'Proyectos', starter: true, pro: true, business: true },
      { code: 'feature_work_orders', label: 'Órdenes de trabajo', starter: true, pro: true, business: true },
      { code: 'feature_my_tasks', label: 'Mis tareas', starter: false, pro: true, business: true },
      { code: 'feature_scheduling', label: 'Agendamiento', starter: false, pro: true, business: true },
      { code: 'feature_workspace', label: 'Tablero', starter: false, pro: true, business: true }
    ]
  },
  {
    key: 'inventory',
    label: 'Inventario y producción',
    features: [
      { code: 'feature_inventory', label: 'Inventario', starter: false, pro: true, business: true },
      {
        code: 'feature_warehouse_accounting',
        label: 'Contabilidad de bodega',
        starter: false,
        pro: false,
        business: true
      },
      { code: 'feature_recipes', label: 'Recetas', starter: false, pro: true, business: true },
      { code: 'feature_recipes_qr', label: 'Recetas con QR', starter: false, pro: false, business: true }
    ]
  },
  {
    key: 'accounting',
    label: 'Contabilidad y finanzas',
    features: [
      { code: 'feature_payments', label: 'Pagos', starter: true, pro: true, business: true },
      {
        code: 'feature_editable_chart_of_accounts',
        label: 'Plan de cuentas editable',
        starter: false,
        pro: true,
        business: true
      },
      { code: 'feature_business_centers', label: 'Centros de negocio', starter: false, pro: true, business: true }
    ]
  },
  {
    key: 'approvals',
    label: 'Aprobaciones (Visto Bueno)',
    features: [
      { code: 'feature_vb_quotes', label: 'Aprobación de cotizaciones', starter: false, pro: true, business: true },
      {
        code: 'feature_vb_purchase_orders',
        label: 'Aprobación de órdenes de compra',
        starter: false,
        pro: false,
        business: true
      },
      { code: 'feature_vb_payments', label: 'Aprobación de pagos', starter: false, pro: false, business: true }
    ]
  },
  {
    key: 'ai',
    label: 'IA e integraciones',
    features: [{ code: 'feature_mcp', label: 'Agente IA (MCP)', starter: true, pro: true, business: true }]
  }
];

// value 0 = ilimitado (same convention as the core's card_limits).
export const PLAN_LIMITS = [
  { code: 'limit_crm_contacts', label: 'Leads CRM', starter: 100, pro: 1000, business: 10000 },
  { code: 'limit_active_users', label: 'Usuarios activos', starter: 1, pro: 0, business: 0 },
  { code: 'limit_bank_connections', label: 'Bancos conectados', starter: 1, pro: 2, business: 5 },
  { code: 'limit_hr_users', label: 'Usuarios en RRHH', starter: 1, pro: 25, business: 100 },
  { code: 'limit_expense_report_users', label: 'Usuarios de rendiciones', starter: 1, pro: 5, business: 25 },
  { code: 'limit_external_stores', label: 'Tiendas externas', starter: 1, pro: 3, business: 0 },
  { code: 'limit_api_calls_daily', label: 'Llamadas API por día', starter: 100, pro: 1000, business: 10000 }
];

export const formatLimit = value => (value === 0 ? 'Ilimitado' : value.toLocaleString('es-CL'));
